import { Box, Typography } from "@mui/material"

import UIIcon from "../UIIcon"

import { MenuItemProps } from "./props"
import { ContentContainer, TextContainer } from "./styled"

export const MenuItem = ({ icon, title, subtitle, onClick }: MenuItemProps) => (
  <Box sx={ContentContainer} onClick={onClick}>
    <UIIcon iconName={icon} size={46} />
    <Box sx={TextContainer}>
      <Typography variant="h4">{title}</Typography>
      {subtitle && <Typography variant="h7Pale">{subtitle}</Typography>}
    </Box>
  </Box>
)
